import PlanetList from "./planet-list";

export default PlanetList;
